module.exports = __webpack_public_path__ + "img/example_news.cf93d852.png";